import { render } from "./AddProduct.vue?vue&type=template&id=4c35cb92&scoped=true&ts=true"
import script from "./AddProduct.vue?vue&type=script&lang=ts"
export * from "./AddProduct.vue?vue&type=script&lang=ts"

import "./AddProduct.vue?vue&type=style&index=0&id=4c35cb92&lang=css"
import "./AddProduct.vue?vue&type=style&index=1&id=4c35cb92&lang=scss&scoped=true"

import exportComponent from "D:\\YellowBeardProject\\caffeine\\caffeineshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c35cb92"]])

export default __exports__